function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg from 'ha/ui/next/SvgIcon';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.5 18a2 2 0 0 0 2 2h19a2 2 0 0 0 2-2V9.5a.25.25 0 0 0-.25-.25H.75a.25.25 0 0 0-.25.25zM17 15.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5zm-12.5-4h8a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1 0-1.5zm0 4h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5zM23.5 6a2 2 0 0 0-2-2h-19a2 2 0 0 0-2 2v1.5a.25.25 0 0 0 .25.25h22.5a.25.25 0 0 0 .25-.25z"
});

var SvgCreditCard1Bold = function SvgCreditCard1Bold(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgCreditCard1Bold;